module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAHBAMAAADDgsFQAAAAGFBMVEUAAADx8/Tx8/Tx8/Tx8/Tx8/Tx8/Tx8/TgcsBBAAAAB3RSTlMAB+q3tiskIQDopwAAADBJREFUCNdjYExgYBNgEFFlCHJkEC4KVTdkYDRXKhZgYBApN2RgYGB0FmAAAkEGBgBsZwR03/m+iAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_down1.png
// module id = cjAb
// module chunks = 9